import http from './http-common';

export const setAuthToken = (token: string) => {
  if (token) {
    http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  } else {
    http.defaults.headers.common['Authorization'] = '';
  }
};
